/**
 * @generated SignedSource<<c3d689adf4e97b04ae2da5ee81896b5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type UtilizationGrantUpdateInput = {
  id: string;
  permissions: ReadonlyArray<UtilizationGrantPermission>;
};
export type sharedAccessPageUpdateMutation$variables = {
  input: UtilizationGrantUpdateInput;
};
export type sharedAccessPageUpdateMutation$data = {
  readonly lockUtilizationGrantUpdate: {
    readonly id: string;
    readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
  };
};
export type sharedAccessPageUpdateMutation = {
  response: sharedAccessPageUpdateMutation$data;
  variables: sharedAccessPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedAccessPageUpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sharedAccessPageUpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d42ccd4d97f67bb1fe31c3f2f38629bc",
    "id": null,
    "metadata": {},
    "name": "sharedAccessPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation sharedAccessPageUpdateMutation(\n  $input: UtilizationGrantUpdateInput!\n) {\n  lockUtilizationGrantUpdate(input: $input) {\n    id\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fc7e0d8eaae2a17bdba816f8bc6fd03";

export default node;
